import { gql } from '@apollo/client';
const SET_ORDER_COMPONENT_VARIANT_TO_READY = gql `
  mutation SetOrderComponentVariantToReady($orderComponentVariantId: ID!) {
    setOrderComponentVariantToReady(orderComponentVariantId: $orderComponentVariantId) {
      orderComponentVariant {
        id
      }
    }
  }
`;
export default SET_ORDER_COMPONENT_VARIANT_TO_READY;
